import styled from '@emotion/styled';
import {
  Button,
  ButtonWithForwardRef,
  colors,
  DraggableMenu,
  DraggableMenuItem,
  DropdownButton,
  DropdownMenu,
  Popover,
  Stack,
  Typography,
} from '@ui-components/neo.tax';
import { ReactComponent as PlusIcon } from '@ui-components/neo.tax/dist/icons/plus.svg';
import { ReactComponent as SortIcon } from '@ui-components/neo.tax/dist/icons/sort.svg';
import { ReactComponent as TrashBin } from '@ui-components/neo.tax/dist/icons/trash-bin-fill.svg';

import { screenMd, ZIndex } from '@neo.tax/shared/utils';

export const StyledConfigDropdownMenu = styled(DropdownMenu)({
  width: 200,
  '> span': {
    color: colors.gray[400],
  },
}) as typeof DropdownMenu;

export const StyledDropdownButton = styled(DropdownButton)([
  { flex: 1 },
  screenMd({
    '.menu-value': {
      display: 'none',
    },
  }),
]) as typeof DropdownButton;

export const StyledPopover = styled(Popover)({
  padding: '1rem 1.5rem',
  minWidth: '40rem',
  zIndex: ZIndex.MODAL,
});

const iconStyle = { color: colors.gray[400] };

export const StyledSortIcon = styled(SortIcon)(iconStyle);

export const StyledAddConditionButton = styled(ButtonWithForwardRef)({ margin: 0 });

export const StyledResetButton = styled(Button)({ margin: 0 });

export const StyledMenuItemInnerContainer = styled(Stack)({
  height: 38,
  paddingLeft: 13,
});

export const StyledTitle = styled(Typography)({
  width: 100,
  padding: '9px 0',
  color: colors.gray[400],
});

export const StyledPopoverTitle = styled(Typography)({
  color: colors.gray[400],
});

export const StyledPopoverTitleSemibold = styled(Typography)({
  color: colors.gray[500],
});

export const StyledPlusIcon = styled(PlusIcon)({
  height: 24,
  width: 24,
  marginTop: -4,
  marginLeft: -2,
});

export const StyledDraggableMenu = styled(DraggableMenu)({
  borderStyle: 'none',
}) as typeof DraggableMenu;

export const StyledDraggableMenuItem = styled(DraggableMenuItem)({
  borderStyle: 'none',
});

// delete button
export const StyledDeleteButton = styled(Button)({ padding: 9, margin: 0 });

export const StyledTrashBin = styled(TrashBin)({ height: 20, width: 20 });
